import { Provider } from '@angular/core';
import { MAT_ICON_DEFAULT_OPTIONS } from '@angular/material/icon';

export const MATERIAL_SYMBOLS_FONT_SET = 'material-symbols-outlined';

/**
 * `MatIcon` falls back to the legacy "Material Icons" font when a `fontSet` is
 * absent.  That font is no longer loaded, so without this default an icon
 * without an explicit `fontSet` renders its ligature name as plain text.
 */
export const provideMaterialSymbols = (): Provider => ({
  provide: MAT_ICON_DEFAULT_OPTIONS,
  useValue: { fontSet: MATERIAL_SYMBOLS_FONT_SET },
});
